import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { InvestorCheckedOut } from "../../../utils/inv-exch-amplitude";
interface CheckoutProps {
  acctId: string;
  pubPropertySfId: string;
  acctSfid: string;
  interestScore: number;
  property_address: string;
  onSuccess?: void | ((data: any) => void);
  onError?: void | ((error: any) => void);
}

interface CheckoutBody {
  acctId: string;
  pubPropertyId: string;
}

export const useCheckout = ({
  acctId,
  pubPropertySfId,
  acctSfid,
  interestScore,
  property_address,
  onSuccess,
  onError
}: CheckoutProps) => {
  const { t } = useTranslation();
  const axios = useAxios();
  const queryClient = useQueryClient();
  const url = t("inv-exchange-checkout");

  return useMutation({
    mutationFn: async (data: CheckoutBody) => {
      const response = await axios.post(`${url}`, data);
      InvestorCheckedOut({
        investor_id: acctId,
        investor_sfid: acctSfid,
        property_id: data.pubPropertyId,
        property_sfid: pubPropertySfId,
        interest_score: interestScore || 0,
        property_address: property_address
      });
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.setQueriesData(
        { queryKey: ["flipper-vaults"] },
        (oldData: any) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page: any) => ({
              ...page,
              accounts: page?.accounts.map((account: any) => {
                if (account?.acctId === acctId) {
                  const newCheckouts = [
                    ...(account?.checkouts || []),
                    {
                      ...data?.data,
                      expirtyAt: moment(data.data.expiryAt).utc(),
                      bidCount: 0
                    }
                  ].sort(
                    (a: any, b: any) =>
                      moment(a.createdAt).valueOf() -
                      moment(b.createdAt).valueOf()
                  );
                  return {
                    ...account,
                    // acctName: data.data.acctDetails?.acctName,
                    contacts: data.data.acctDetails?.contacts,
                    checkouts: newCheckouts
                  };
                }
                return account;
              })
            }))
          };
        }
      );
      queryClient.invalidateQueries({ queryKey: ["inv-list"] });
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    }
  });
};
